import { ComponentType, useState } from "react";
import { PendingOrgBillingTransferRequest } from "@common/dto/billing/org-billing-transfer-request.dto";
import { usePendingOrgBillingTransfer } from "./usePendingOrgBillingTransfer";

export interface PendingOrgBillingTransferModalProps {
    request: PendingOrgBillingTransferRequest;
    onClose: () => void;
}

export const usePendingOrgBillingTransferModal = (
    Modal: ComponentType<PendingOrgBillingTransferModalProps>,
) => {
    const request = usePendingOrgBillingTransfer();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const modal =
        request && isModalOpen ? (
            <Modal request={request} onClose={() => setIsModalOpen(false)} />
        ) : null;

    return { request, openModal: () => setIsModalOpen(true), modal };
};
